import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function Tr(props: Props) {
  const { children, className } = props;
  return <tr className={className}>{children}</tr>;
}
